import {useTranslation} from '@/translations/i18n'
import {useCallback, useEffect, useRef, useState} from 'react'
import {StyledCommandMenuListResults, StyledGlobalSearchButton, StyledGlobalSearchShortcut} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {SearchSmIcon} from '@/components/ui/icon/Icon'
import {CommandMenu} from '@/components/commons/command-menu/CommandMenu'
import {CommandMenuInput} from '@/components/commons/command-menu-input/CommandMenuInput'
import {useInfinitePatients} from '@/features/patients/services/useInfinitePatients'
import {GlobalSearchLoader} from '@/components/commons/global-search/GlobalSearchLoader'
import {GlobalSearchFooter} from '@/components/commons/global-search/GlobalSearchFooter'
import {GlobalSearchList} from '@/components/commons/global-search/GlobalSearchList'

export const GlobalSearch = () => {
    const {t} = useTranslation()
    const [open, setOpen] = useState(false)

    const {
        remappedData: patients,
        data,
        searchValue,
        onResetSearch,
        isLoading,
        onSearch
    } = useInfinitePatients(
        {
            limit: 20
        },
        {
            enabled: open
        }
    )

    const searchRef = useRef<HTMLInputElement>(null)

    const handleKeyPress = useCallback((event: KeyboardEvent) => {
        if ((event.ctrlKey || event.metaKey) && event.key == 'k') {
            event.preventDefault()
            setOpen(true)
        }
    }, [])

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress)
        return () => document.removeEventListener('keydown', handleKeyPress)
    }, [handleKeyPress])

    const isMac = navigator.userAgent.includes('Mac')

    return (
        <>
            <StyledGlobalSearchButton
                variant="secondary"
                shape="roundedRectangle"
                fullWidth
                onClick={() => setOpen(true)}
            >
                <Flexbox gap={2} align="center" fullWidth>
                    <SearchSmIcon /> {t('commons:go_to')}
                    <StyledGlobalSearchShortcut>{isMac ? 'CMD + K' : 'CTRL + K'}</StyledGlobalSearchShortcut>
                </Flexbox>
            </StyledGlobalSearchButton>

            <CommandMenu open={open} onOpenChange={setOpen} onSearch={onSearch}>
                <Flexbox direction="column" fullWidth>
                    <CommandMenuInput hasSearch={!!searchValue} resetSearch={onResetSearch} ref={searchRef} />
                    {isLoading ? (
                        <GlobalSearchLoader />
                    ) : (
                        <>
                            {data?.pages[0]?.meta && data.pages[0].meta.total > 0 && searchValue && (
                                <StyledCommandMenuListResults>
                                    {t('global_search:patients_found', {count: data.pages[0].meta.total})}
                                </StyledCommandMenuListResults>
                            )}
                            <GlobalSearchList patients={patients} />
                            <GlobalSearchFooter searchValue={searchValue} />
                        </>
                    )}
                </Flexbox>
            </CommandMenu>
        </>
    )
}
